<ng-container *ngIf="isEmpty">
    <div class="empty-list">
        <p i18n>You have not defined any form fields yet.</p>
        <p i18n>Add your first <strong>form field</strong> to build the form.</p>
        <p><button i18n mat-flat-button color="primary" (click)="onAddField()">ADD FORM FIELD</button></p>
    </div>
</ng-container>
<ng-container *ngIf="!isEmpty" >
  <div cdkDropList (cdkDropListDropped)="drop($event, $event.item.data.id)">
    <eas-workflow-form-field-item *ngFor="let item of items; first as isFirst; last as isLast"
                                  [item]="item"
                                  [cdkDragData]="item"
                                  [permission]="permissionForItem(item)"
                                  [canChangePermission]="canChangePermissionForItem(item)"
                                  [isLast]="isLast"
                                  [isFirst]="isFirst"
                                  (editField)="onEditField($event)"
                                  (setPermission)="onSetPermission($event)"
                                  (removePermission)="onRemovePermission($event)"
                                  (moveFieldUp)="onMoveFieldUp($event)"
                                  (moveFieldDown)="onMoveFieldDown($event)"
                                  cdkDrag
    ></eas-workflow-form-field-item>
  </div>

  <div class="mt-5">
      <button i18n mat-flat-button color="primary" (click)="onAddField()">+ ADD FORM FIELD</button>
  </div>
</ng-container>
